import * as HTTP from './http';

export const List = (token) => HTTP.GET('fgs-management', token);
export const Get = (token, id) => HTTP.GET(`fgs-management/${id}`, token);
export const Create = (token, data) => HTTP.POST('fgs-management', data, token);
export const Update = (token, id, data) => HTTP.PATCH(`fgs-management/${id}`, data, token);
export const Activate = (token, id, data) => HTTP.POST(`fgs-management/${id}/activate`, data, token);
export const Deactivate = (token, id, data) => HTTP.POST(`fgs-management/${id}/deactivate`, data, token);
export const History = (token, id) => HTTP.GET(`fgs-management/${id}/history`, token);
export const Preview = (token, data) => HTTP.POST('fgs-management/preview', data, token);
export const ListPrintRoutes = (token) => HTTP.GET('fgs-management/print-routes', token);
export const ShippingOverview = (token) => HTTP.GET('fgs-management/shipping-overview', token);
export const CreatePrintRoute = (token, data) => HTTP.POST('fgs-management/print-routes', data, token);
export const UpdatePrintRoute = (token, id, data) => HTTP.PATCH(`fgs-management/print-routes/${id}`, data, token);
export const PrintRouteHistory = (token, id) => HTTP.GET(`fgs-management/print-routes/${id}/history`, token);
